<template>
  <div id="gallery-box">
    <GalleryItem
      v-for="(item, index) in list"
      :galleryItem="item"
      :key="index"/>
  </div>
</template>

<script>
  import GalleryItem from './GalleryItem'

  export default {
    props: {
      list: {
        type: Array,
        required: true
      }
    },
    components: { GalleryItem },
  }
</script>

<style lang="scss" scoped>
  @import "../styles/stylefunc";
  #gallery-box {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    width: 100%;
    margin-top: 20px;
  }
</style>





// WEBPACK FOOTER //
// src/components/Gallery.vue